import { getLoginInfo, getUserInfo } from 'service/ad-user';
import { createAction } from 'redux-actions';
import actionTypes from './action-types';
import {
    getCollectTagListService,
    getPopulationTypes,
    collectTagService,
    getUserSpeedAuthAndType,
} from 'service/population';
import { getAccountId, setAccountId } from 'utils/login';
import { tagCollectionItem, IFilterTag, PortraitModuleCondition } from './type';
import { addFMP } from '@/utils/businesslog';
import { authGet } from '@/service/swet/auth-controller';

export const getUserInfoThunk =
    (redirectUrl = '') =>
    async (dispatch) => {
        const userInfo = await getUserInfo(redirectUrl);
        if (userInfo.result === 1) {
            const accountId = String(userInfo.userDspAccount.accountUcId);
            const storeInfo = getAccountId();
            setAccountId({
                accountId,
                accountName:
                    userInfo.userDspAccount.accountName || storeInfo?.accountId === accountId
                        ? storeInfo?.accountName
                        : '',
            });
        }

        dispatch(createAction(actionTypes.COMMON.GET_USER_INFO_SUCCESS)({ userInfo }));
    };

export const getPopulationTypesThunk = () => async (dispatch) => {
    const populationTypes = await getPopulationTypes();
    dispatch(createAction(actionTypes.COMMON.GET_POPULATION_TYPES_SUCCESS)({ populationTypes }));
};

export const getLoginInfoThunk = () => async (dispatch) => {
    const userInfo = await getLoginInfo();
    addFMP(); // 首页获取到用户信息后上报 FMP
    dispatch(
        createAction(actionTypes.COMMON.GET_LOGIN_INFO_SUCCESS)({
            loginInfo: userInfo,
        }),
    );
    return userInfo;
};

export const getCollectedTagThunk = () => async (dispatch) => {
    const collectedTags = await getCollectTagListService();
    dispatch(
        createAction(actionTypes.COMMON.GET_COLLECTED_TAG_SUCCESS)({
            tagCollection: collectedTags,
        }),
    );
    return collectedTags;
};

export const getUserModelSpeedAuthThunk = (id) => async (dispatch) => {
    const userAuthAndType = await getUserSpeedAuthAndType(id);
    dispatch(
        createAction(actionTypes.COMMON.GET_USER_MODEL_AUTH_SUCCESS)({
            authorizeAndType: userAuthAndType,
        }),
    );
    return userAuthAndType;
};

// 私有建模权限
export const getUserPrivateModelAuthThunk = () => async (dispatch) => {
    let privateModelAuth = false;
    try {
        const { data } = await authGet();
        privateModelAuth = data ?? false;
    } catch (e) {}
    dispatch(
        createAction(actionTypes.COMMON.GET_USER_PRIVATE_MODEL_AUTH_SUCCESS)({
            privateModelAuth: privateModelAuth,
        }),
    );
    return privateModelAuth;
};

export const collectTagActionThunk = (tagItem: tagCollectionItem) => async (dispatch) => {
    const collectTagRes = await collectTagService(tagItem.tagId, 1);
    dispatch(
        createAction(actionTypes.COMMON.COLLECT_TAG_SUCCESS)({
            tagCollection: [{ ...tagItem }],
        }),
    );
    return collectTagRes;
};

export const unCollectTagActionThunk = (tagItem: tagCollectionItem) => async (dispatch) => {
    const unCollectTagRes = await collectTagService(tagItem.tagId, 2);
    dispatch(
        createAction(actionTypes.COMMON.UNCOLLECT_TAG_SUCCESS)({
            tagCollection: [{ ...tagItem }],
        }),
    );
    return unCollectTagRes;
};

export const portraitTagListThunk = (value: IFilterTag[] | null) => (dispatch) => {
    dispatch(
        createAction(actionTypes.COMMON.PORTRAIT_TAG_LIST_SUCCESS)({
            portraitTagList: value,
        }),
    );
};

export const portraitModuleConditionThunk = (value: PortraitModuleCondition) => (dispatch) => {
    dispatch(
        createAction(actionTypes.COMMON.PORTRAIT_MODULE_CONDITION_SUCCESS)({
            portraitModuleCondition: value,
        }),
    );
};

// 暂时-开关状态
export const OpenSwitchThunk = (value: boolean) => (dispatch) => {
    dispatch(
        createAction(actionTypes.COMMON.SWITCH_SUCCESS)({
            isOpenSwitch: value,
        }),
    );
};

// 是否展示拖拽标签后的引导
export const showDragLabelGuideThunk = (value: boolean) => (dispatch) => {
    dispatch(
        createAction(actionTypes.COMMON.DRAG_LABEL_SUCCESS)({
            isDragTagGuideShow: value,
        }),
    );
};
